__turbopack_context__.v({
  "frame": "SectionLoadingOverlay-module-scss-module__-3ORDG__frame",
  "label": "SectionLoadingOverlay-module-scss-module__-3ORDG__label",
  "overlay": "SectionLoadingOverlay-module-scss-module__-3ORDG__overlay",
  "overlayTransparent": "SectionLoadingOverlay-module-scss-module__-3ORDG__overlayTransparent",
  "spin": "SectionLoadingOverlay-module-scss-module__-3ORDG__spin",
  "spinner": "SectionLoadingOverlay-module-scss-module__-3ORDG__spinner",
});
